import { SKIP_VALIDATION_PARAMS } from '@app/plp/constants/facetedNavigation';

// Validate query param values against Algolia to prevent invalid
// filter values (injected by legacy pages) from returning empty PLPs
export const validateQueryFacet = (
    refinementId: string,
    value: string,
    algoliaFilters: Record<string, string[]>
) => {
    if (SKIP_VALIDATION_PARAMS.includes(refinementId)) {
        return true;
    }

    const matchedValue = algoliaFilters[refinementId]?.find(
        validValue => validValue === decodeURIComponent(value)
    );

    return Boolean(matchedValue);
};
